<div class="h-full relative bg-background-secondary">
  <button
    class="absolute right-[10px] top-[5px]"
    mat-icon-button
    mat-dialog-close
    data-test="data-test-dialog-button-close"
  >
    <fa-icon class="fs-8 text-gray-700" [icon]="['fal', 'times']"></fa-icon>
  </button>
  <div class="w-full aligner-start h-[50px] px-3 border-bottom pr-14">
    <div class="dialog-header truncate">
      Built-In Test Suite for:
      <img class="icon" *ngIf="state.headerIcon" [src]="state.headerIcon" [alt]="state.tablePath" />
      {{ state.tablePath }}
    </div>
    <button
      class="ml-2 font-normal border-common"
      mat-button
      (click)="toggleDataPreview()"
      [color]="state.dataPreviewOpened ? 'accent' : 'primary'"
      [disabled]="state.dataPreviewButtonDisabled"
      [attr.data-test]="
        state.dataPreviewOpened ? 'data-test-dialog-button-close-preview' : 'data-test-dialog-button-preview-table-data'
      "
    >
      {{ state.dataPreviewOpened ? 'Close Preview' : 'Preview Table Data' }}
    </button>
  </div>
  <as-split [gutterSize]="5" direction="horizontal" style="height: calc(100% - 50px)">
    <as-split-area [size]="state.dataPreviewOpened ? 50 : 100">
      <div class="flex flex-col h-full">
        <mat-tab-group [selectedIndex]="state.tabSelectedIndex" (selectedIndexChange)="changeTabSelectedIndex($event)">
          <mat-tab data-test="data-test-dialog-tab-job-overview">
            <ng-template mat-tab-label>
              <span class="tab-text">
                <img [src]="jobOverviewIcon" class="mr-1" alt="Job Overview" />
                Job Overview
              </span>
            </ng-template>
            <ng-template matTabContent></ng-template>
          </mat-tab>
          <mat-tab data-test="data-test-dialog-tab-table-setup">
            <ng-template mat-tab-label>
              <span class="tab-text">
                <img [src]="testSetupIcon" class="mr-1" alt="Data tests set-up" />
                Test Set-Up
              </span>
            </ng-template>
            <ng-template matTabContent></ng-template>
          </mat-tab>
        </mat-tab-group>
        <div class="box-2 ag-grid-container">
          <!--
            todo: TECH-7874 put the components inside the mat-tab-group (some css fixes needed)
       -->
          <y42-data-test-job-overview-list *ngIf="state.tabSelectedIndex === 0"></y42-data-test-job-overview-list>

          <y42-container-with-side-detail-view *ngIf="state.tabSelectedIndex === 1" [hideHeader]="true">
            <y42-data-test-setup-list></y42-data-test-setup-list>
            <ng-template y42SideDetailView>
              <y42-data-test-builder-container></y42-data-test-builder-container>
            </ng-template>
          </y42-container-with-side-detail-view>
        </div>
      </div>
    </as-split-area>
    <as-split-area [size]="50" *ngIf="state.dataPreviewOpened">
      <y42-table-viewer [tableId]="state.tablePath"></y42-table-viewer>
    </as-split-area>
  </as-split>
</div>
